import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (params) {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: '',
    name: 'GET_SHUTDOWN_ANALYSIS',
    manual: false
  });
  useEffect(() => {
    if (params) {
      let url = `/api/shutdown/status/analysis`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?'
        } else {
          url += '&'
        }
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [ data || [], exec,isRequestSuccessed];
});
